module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"selected_kpis":"選択KPI({0})","apply":"適用","cancel":"キャンセル","requirement_alert":"少なくとも4 KPIを選択してください！|"}}')
  delete Component.options._Ctor
}
